export default __webpack_public_path__ + "static/media/Devices.263f1e70.mp4";